import React from 'react';
import Checkbox from '@mui/material/Checkbox';

export default function CheckboxComponent(props) {
  return (
    <Checkbox {...props} />
  )
}
